import React, { FunctionComponent } from "react";
import { NavLink } from "react-router-dom";

type GameInfoNavProps = {
  gameCode: string;
};
export const GameInfoNav: FunctionComponent<GameInfoNavProps> = ({
  gameCode,
}) => {
  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark sticky-top">
        <ul className="navbar-nav me-auto mb-lg-0 px-2">
          <li className="nav-item">
            <NavLink className="nav-link" to={`/${gameCode}/rules`}>
              Rules
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link" to={`/${gameCode}/settings`}>
              Settings
            </NavLink>
          </li>
        </ul>
      </nav>
    </>
  );
};
